import React from 'react'

import MemberSelectorTable from '../MemberSelectorTable'

import './style.styl'

const AddTeamMembers = ({ teamMembers, onSave, onCancel, backLinkText, onBackLinkClick }) => (
  <div className="team-modal-content-container">
    <h4 className="team-modal-header">Add teammates</h4>
    <div className="team-modal-content">
      <MemberSelectorTable teamMembers={teamMembers} onSave={onSave} onCancel={onCancel} />
    </div>
  </div>
)

export default AddTeamMembers



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/AddTeamMembers/index.js